import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import countries from "../data/countries";

export default function ConsultationForm() {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        type_of_service: "",
        place_of_residence: "",
        country: "",
        more_details: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("https://ligasos-laravel.ligasos.co/api/consultations", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                Swal.fire({
                    title: t("Success!"),
                    text: t("Consultation submitted successfully"),
                    icon: "success",
                    confirmButtonText: t("OK"),
                });
                setFormData({
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone_number: "",
                    type_of_service: "",
                    place_of_residence: "",
                    country: "",
                    more_details: "",
                }); // Clear form
            } else {
                Swal.fire({
                    title: t("Error"),
                    text: t(result.message || "Something went wrong"),
                    icon: "error",
                    confirmButtonText: t("OK"),
                });
            }
        } catch (error) {
            Swal.fire({
                title: t("Error"),
                text: t("Failed to connect to the server"),
                icon: "error",
                confirmButtonText: t("OK"),
            });
        }
    };

    return (
        <section className="relative py-[40px]">
            <div className="container">
                <form onSubmit={handleSubmit}>
                    <div className="flex flex-col gap-[15px]">
                        <div className="f-col flex gap-[20px]">
                            <div className="w-100 w-[48%] flex flex-col gap-[10px]">
                                <div className="flex flex-col gap-[7px]">
                                    <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                        {t("First Name")}
                                    </label>
                                    <input
                                        name="first_name"
                                        className="border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        type="text"
                                        placeholder={t("First Name")}
                                        value={formData.first_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col gap-[7px]">
                                    <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                        {t("Email")}
                                    </label>
                                    <input
                                        name="email"
                                        className="border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        type="email"
                                        placeholder={t("Email")}
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="flex flex-col gap-[7px]">
                                    <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                        {t("Type Of Service")}
                                    </label>
                                    <select
                                        name="type_of_service"
                                        className="border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        value={formData.type_of_service}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>
                                            {t("Select Type Of Service")}
                                        </option>
                                        <option value="property-sales">{t("Property Sales")}</option>
                                        <option value="property-rentals">{t("Property Rentals")}</option>
                                        <option value="property-management">{t("Property Management")}</option>
                                        <option value="investment-consultancy">{t("Investment Consultancy")}</option>
                                        <option value="real-estate-valuation">{t("Real Estate Valuation")}</option>
                                        <option value="legal-assistance">{t("Legal Assistance")}</option>
                                    </select>
                                </div>
                            </div>
                            <div className="w-100 w-[48%] flex flex-col gap-[10px]">
                                <div className="flex flex-col gap-[7px]">
                                    <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                        {t("Last Name")}
                                    </label>
                                    <input
                                        name="last_name"
                                        className="border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        type="text"
                                        placeholder={t("Last Name")}
                                        value={formData.last_name}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="flex flex-col gap-[7px]">
                                    <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                        {t("Phone Number")}
                                    </label>
                                    <input
                                        name="phone_number"
                                        className="border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                        type="text"
                                        placeholder={t("Phone Number")}
                                        value={formData.phone_number}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="flex flex-col gap-[7px]">
                                    <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                        {t("Your Place Of Residence")}
                                    </label>
                                    <select
                                        name="country"
                                        className="border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px] text-black"
                                        value={formData.country}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">{t("Select Your Country")}</option>
                                        {countries.map((country, index) => (
                                            <option className="text-black" key={index} value={country.name}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="w-[100%] flex flex-col gap-[7px]">
                            <label className="font-bold text-[22px] text-[#132A40] capitalize">
                                {t("More Details")}
                            </label>
                            <textarea
                                name="more_details"
                                className="h-[250px] max-h-[350px] border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                placeholder={t("More Details")}
                                value={formData.more_details}
                                onChange={handleChange}
                            ></textarea>
                        </div>
                        <button
                            type="submit"
                            className="w-fit bg-[#132A40] text-white px-[40px] py-[8px] rounded font-bold capitalize"
                        >
                            {t("send")}
                        </button>
                    </div>
                </form>
            </div>
        </section>
    );
}